module.exports = __webpack_public_path__ + "static/media/cloud3.08b29c70.svg";